module.exports = __webpack_public_path__ + "static/media/varie9.d79dac8f.jpg";